// type
import { DialogOptions } from "../types/dialogOptions";

/**
 * ErrorDialogController
 */
class ErrorDialogController {
    private static handler: ((options: DialogOptions) => void) | null = null;
    private static navigateFn: ((path: string) => void) | null = null;

    static register(handler: (options: DialogOptions) => void) {
        ErrorDialogController.handler = handler;
    }

    static registerNavigate(fn: (path: string) => void) {
        ErrorDialogController.navigateFn = fn;
    }

    static show(options: DialogOptions) {
        if (ErrorDialogController.handler) 
            ErrorDialogController.handler(options);
    }

    static go(path: string) {
        if (ErrorDialogController.navigateFn) 
            ErrorDialogController.navigateFn(path);
    }
}

export default ErrorDialogController;